// test256
(256 && 0);
